import React, { useState } from 'react';
import { Row, Col, InputGroup, Button, Form, FormGroup, Input, Label } from 'reactstrap';

import Body from '../Components/layout/Body';

const CREDENTIAL_HELP = `
<div>
  <p>Here is where you can change the password for your practitioner account.</p>
  <p>You'll need to enter your account Username and Current Password. So we know it's you.</p>
  <p>Then enter the New Password that you want to use from now on.</p>
  <p><strong>Note: </strong> If you can't remember your current password, go to the Login page and use the 'Forgot password?' link.</p>
</div>
`;

//content sub-component with unique content for this page
function UsersUpdateCredentialsContent(props) {
  const {
    username,
    oldPassword,
    newPassword,
    onChangeUsername,
    onChangeOldPassword,
    onChangeNewPassword,
    userStatus
  } = props;

  const [isOldPwdHidden, setIsOldPwdHidden] = useState(true);
  const [isNewPwdHidden, setIsNewPwdHidden] = useState(true);
  
  const toggleOldPwd = () => {
    setIsOldPwdHidden(!isOldPwdHidden);
  }
  const toggleNewPwd = () => {
    setIsNewPwdHidden(!isNewPwdHidden);
  }

  return(
    <>
    <Row className="aa-review-row">
      <Col>
        <Form>
          <FormGroup>
            <Label for="username" className="aa-bold-text">
              Username <span className="aa-field-required">*</span>
            </Label>
            <Input
              id="username"
              value={username}
              onChange={onChangeUsername}
              name="username"
              type="textfield"
              invalid={userStatus === 0}
              required
            />
          </FormGroup>
          <FormGroup>
            <Label for="oldPassword" className='aa-bold-text'>
              Current Password <span className="aa-field-required">*</span>
            </Label>
            <InputGroup>
              <Input
                id="oldPassword"
                value={oldPassword}
                onChange={onChangeOldPassword}
                name="oldPassword"
                type={isOldPwdHidden ? "password" : "text"}
                invalid={userStatus === 1}
                required
              />
              <Button outline className="aa-btn-within-field" onClick={toggleOldPwd}
                ><span className={isOldPwdHidden ? 'fa fa-eye' : 'fa fa-eye-slash'}></span>
              </Button>
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label for="newPassword" className='aa-bold-text'>
              New Password <span className="aa-field-required">*</span>
            </Label>
            <InputGroup>
              <Input
                  id="newPassword"
                  value={newPassword}
                  onChange={onChangeNewPassword}
                  name="newPassword"
                  type={isNewPwdHidden ? "password" : "text"}
                  required
                  /> 
              <Button outline className="aa-btn-within-field" onClick={toggleNewPwd}
                ><span className={isNewPwdHidden ? 'fa fa-eye' : 'fa fa-eye-slash'}></span>
              </Button>       
            </InputGroup>
          </FormGroup>
        </Form>
      </Col>
      {/* puts a little margin on the right, for large screen sizes */}
      {/* <div className="col-lg-4"></div> */}
      <Col lg="4"></Col>
    </Row>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function UsersUpdateCredentials(props) {
  const {
    username,
    oldPassword,
    newPassword,
    onChangeUsername,
    onChangeOldPassword,
    onChangeNewPassword,
    userStatus,
    onContinue
  } = props;

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used, but could supply an image on page
    faIcon: "fa-users aa-fa-3x", //include this font-awesome icon in the image column of the page
    title: "Change your password",
    subTitle: "",
    learnMore: {linkText: "Learn More about changing your password",
                title: "Changing your password",
                content: CREDENTIAL_HELP
                },
    nextRoute: '', //EVAL_INTRO, //static name for next page since this never changes
    sidebar: false
  }

  console.log("rendering UsersUpdateCredentials");

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <UsersUpdateCredentialsContent 
          username={username}
          onChangeUsername={onChangeUsername}
          oldPassword={oldPassword}
          onChangeOldPassword={onChangeOldPassword}
          newPassword={newPassword}
          onChangeNewPassword={onChangeNewPassword}
          userStatus={userStatus}
        />
      } 
      onContinue={onContinue}
    />
    </>
  );
}

export default UsersUpdateCredentials;